import { DiscountModel, serviceCostModel, serviceModel } from "../../models";
import { OneTimeInStagesError } from "../../models/service/logic";
import { utils } from "../../utils";
export function getStatusBadgeText(service, isActiveAgreement, disableStatusBadge) {
  if (disableStatusBadge) return null;
  return serviceModel.matchStatus(service.status, {
    amended: () => 'Amended',
    awaitingApproval: () => isActiveAgreement ? 'New Service' : null,
    completed: () => 'Completed',
    terminated: () => 'Stopped',
    canceled: () => 'Canceled',
    approved: () => null
  });
}
export function getDiscountString(discount) {
  const normalized = discount || DiscountModel.makeValue(0);
  return normalized.accept({
    whenPercent: () => "".concat(normalized.amount(), "% Off"),
    whenValue: () => "$".concat(normalized.amount(), " Off")
  });
}
export function getPriceDisplayProps(service, agreementData) {
  const isActiveAgreement = agreementData.isActiveAgreement();
  return serviceCostModel.match(service.cost, {
    fixed: cost => ({
      priceAfterDiscount: utils.formatDollarAmount(utils.applyDiscount(cost.price, cost.discount)),
      priceBeforeDiscount: cost.discount ? utils.formatDollarAmount(cost.price) : undefined,
      error: serviceModel.validateOneTimeInStages(service).includes(OneTimeInStagesError.NonPercentageDiscount),
      service,
      isActiveAgreement
    }),
    variable: cost => ({
      priceAfterDiscount: utils.formatDollarAmount(utils.applyDiscount(cost.price, cost.discount)),
      priceBeforeDiscount: cost.discount ? utils.formatDollarAmount(cost.price) : undefined,
      postfixPrice: "/".concat(cost.unitName || 'hr'),
      service,
      isActiveAgreement
    }),
    range: cost => {
      const getRangePriceString = (minPrice, maxPrice) => minPrice === null || minPrice.isZero() ? "Up to ".concat(utils.formatDollarAmount(maxPrice)) : "".concat(utils.formatDollarAmount(minPrice), " - ").concat(utils.formatDollarAmount(maxPrice));
      const finalMaxPrice = utils.applyDiscount(cost.maxPrice, cost.discount);
      const priceAfterDiscount = getRangePriceString(cost.minPrice ? utils.applyDiscount(cost.minPrice, cost.discount) : null, finalMaxPrice);
      const priceBeforeDiscount = cost.discount ? getRangePriceString(cost.minPrice, cost.maxPrice) : undefined;
      return {
        priceAfterDiscount,
        priceBeforeDiscount,
        service,
        isActiveAgreement
      };
    }
  });
}
export function getPausedBadge(service, isVendor, isActiveAgreement) {
  const badge = {
    tooltip: isVendor ? 'Automatic billing is paused for this service. To resume, go to the Billing Hub.' : 'Automatic billing is paused for this service.'
  };
  if (serviceModel.isPaused(service)) {
    return serviceModel.matchStatus(service.status, {
      approved: () => badge,
      amended: () => badge,
      awaitingApproval: () => isActiveAgreement ? badge : null,
      completed: () => null,
      terminated: () => null,
      canceled: () => null
    });
  } else {
    return null;
  }
}